import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const rootContainer = css({
  display: "inline-flex",
  flexDirection: "column",
  width: "100%",
  minWidth: 200,
  height: "fit-content",
});

export const dropIcon = (theme: ExactTheme) =>
  css({ flexShrink: 0, isolation: "isolate", color: theme.colorsV2.grey[600] });

export const errorIcon = (theme: ExactTheme) =>
  css({ flexShrink: 0, isolation: "isolate", color: theme.colorsV2.red[500] });

export const rootInput =
  ({ isDrag, error }: { isDrag: boolean; error: boolean }) =>
  ({ colorsV2, fontWeights }: ExactTheme) =>
    css({
      position: "relative",
      display: "flex",
      alignItems: "center",
      padding: 15,
      fontWeight: fontWeights.semibold,

      label: {
        position: "relative",
        height: "100%",
        width: "100%",
        textAlign: "start",
        alignContent: "center",
        padding: "0 10px",
        // whiteSpace: "nowrap",
        // overflow: "hidden",
        // textOverflow: "ellipsis",
        userSelect: "none",
      },
      backgroundColor: error ? colorsV2.red[25] : "transparent",

      ".dragOver": {
        position: "absolute",
        placeContent: "center",
        textAlign: "center",
        inset: 0,
        backgroundColor: colorsV2.grey[25],
        opacity: isDrag ? 1 : 0,
        willChange: "opacity",
        transition: "opacity 200ms",
        pointerEvents: "none",
      },
    });

export const rootDropZoneStyle =
  ({ error, disabled }: { error?: string; disabled?: boolean }) =>
  ({
    borderRadiusV2,
    fontWeights,
    fontSizesV2,
    colorsV2,
    inputBorderV2,
  }: ExactTheme) => {
    return css({
      position: "relative",
      display: "inline-flex",
      flexDirection: "column",
      width: "100%",
      // minHeight: 80,
      borderRadius: borderRadiusV2.primary,
      overflow: "hidden",
      fontWeight: fontWeights.normal,
      fontSize: fontSizesV2.body,
      background: disabled ? colorsV2.grey[50] : colorsV2.white,
      pointerEvents: disabled ? "none" : "all",
      color: colorsV2.grey[800],
      outline: "none",

      border:
        inputBorderV2.dashed[disabled ? "disabled" : "standard"][
          error ? "error" : "default"
        ],

      ...(!disabled && {
        // ":hover": {
        //   border: inputBorderV2.dashed.hover[error ? "error" : "default"],
        // },

        ":focus-visible": {
          border: inputBorderV2.dashed.focused[error ? "error" : "default"],
          boxShadow: error
            ? `0 0 0 1px${colorsV2.red[500]}`
            : `0 0 0 1px${colorsV2.blue[500]}`,
        },
      }),
    });
  };

export const error = (theme: ExactTheme) =>
  css({
    height: 16,
    margin: 0,
    alignContent: "end",

    color: theme.colorsV2.red[600],
    fontSize: theme.fontSizesV2.body2,
  });

export const validParameters = () => (theme: ExactTheme) =>
  css({
    color: theme.colorsV2.grey[800],
    margin: 0,
    fontSize: theme.fontSizesV2.body,
    padding: "10px 15px",
    borderTop: `1px solid ${theme.colorsV2.grey[100]}`,
  });
